<agr-form-dialog [formGroup]="formGroup" (confirm)="save()" (cancel)="cancel()" [data]="data">
  <div class="flex--column">
    <mat-form-field class="flex__child--auto spacing--padding-top">
      <mat-label>{{ 'arrival.arrival-date' | translate }}</mat-label>
      <input
        formControlName="arrivalDate"
        matInput
        [matDatepicker]="arrivalDatePicker"
        placeholder="{{ 'arrival.arrival-date' | translate }}"
        data-test="arrival-item__arrival-date"
      />
      <mat-datepicker-toggle matIconSuffix [for]="arrivalDatePicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #arrivalDatePicker></mat-datepicker>
      <mat-error *ngIf="formGroup.controls.arrivalDate.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
      <mat-error
        *ngIf="
          !!formGroup.controls.arrivalDate.errors &&
          formGroup.controls.arrivalDate.errors.arrivalDateBeforeBirthDate
        "
      >
        {{ 'arrival.arrivaldate-before-birthdate' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'arrival.chick-birth-date' | translate }}</mat-label>
      <input
        formControlName="chickBirthDate"
        matInput
        [matDatepicker]="chickBirthDatePicker"
        placeholder="{{ 'arrival.chick-birth-date' | translate }}"
        data-test="arrival-item__chick-birth-date"
      />
      <mat-datepicker-toggle matIconSuffix [for]="chickBirthDatePicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #chickBirthDatePicker></mat-datepicker>
      <mat-error *ngIf="formGroup.controls.chickBirthDate.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="flex__child--auto" *ngIf="hatcheries$ | async as hatcheries">
      <mat-label>{{ 'arrival.hatchery' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'arrival.hatchery' | translate }}"
        formControlName="hatchery"
        data-test="arrival-item__hatchery"
      >
        <mat-option *ngFor="let hatchery of hatcheries" [value]="hatchery">
          {{ hatchery.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.controls.hatchery.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'breed' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'breed' | translate }}"
        formControlName="breed"
        data-test="arrival-item__breed"
      >
        <mat-option *ngFor="let breed of breeds" [value]="breed">{{ breed.name }}</mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.controls.breed.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'gender' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'gender' | translate }}"
        formControlName="gender"
        data-test="arrival-item__gender"
      >
        <mat-option *ngFor="let gender of genders" [value]="gender">
          {{ gender.toString() | translate }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.controls.gender.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'arrival.nr-of-animals' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        formControlName="numberOfAnimals"
        placeholder="{{ 'arrival.nr-of-animals' | translate }}"
        data-test="arrival-item__nr-of-animals"
      />
      <mat-error *ngIf="formGroup.controls.numberOfAnimals.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'arrival.gps-number' | translate }}</mat-label>
      <input
        matInput
        formControlName="gpsNumber"
        placeholder="{{ 'arrival.gps-number' | translate }}"
        data-test="arrival-item__gps-number"
      />
      <mat-error *ngIf="formGroup.controls.gpsNumber.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'arrival.gps-birth-date' | translate }}</mat-label>
      <input
        formControlName="gpsBirthDate"
        matInput
        [matDatepicker]="gpsBirthDatePicker"
        placeholder="{{ 'arrival.gps-birth-date' | translate }}"
        data-test="arrival-item__gps-birth-date"
      />
      <mat-datepicker-toggle matIconSuffix [for]="gpsBirthDatePicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #gpsBirthDatePicker></mat-datepicker>
      <mat-error *ngIf="formGroup.controls.gpsBirthDate.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'arrival.gps-country' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'arrival.gps-country' | translate }}"
        formControlName="gpsCountry"
        data-test="arrival-item__gps-country"
      >
        <mat-option *ngFor="let country of countries" [value]="country">
          {{ 'countries.' + country.id | translate }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.controls.gpsCountry.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>

    <div
      class="spacing--padding-half-all text--bold heading-wrapper spacing--padding-top spacing--padding-half-bottom"
    >
      {{ 'arrival.allocations-title' | translate }}
      <div class="border-top--gray3 horizontal-line spacing--margin-half-left"></div>
    </div>
    <p *ngIf="!!!allocations || allocations.length === 0" class="text--small text--gray">
      {{ 'arrival.allocations-empty' | translate }}
    </p>
    <span
      *ngIf="!isValidSumOfAllocationsAmounts"
      class="custom-properties-validation spacing--padding-half-top spacing--margin-half-left"
    >
      {{ 'arrival.allocations-invalid-sum-error' | translate }}
    </span>
    <span
      *ngIf="!!isValidCumulativeSectionSurfaceAreas"
      class="custom-properties-validation spacing--padding-half-top spacing--margin-half-left"
    >
      {{ 'arrival.allocations-invalid-cumulative-section-surfaceareas-error' | translate }} ({{
        isValidCumulativeSectionSurfaceAreas.barn
      }}, {{ isValidCumulativeSectionSurfaceAreas.sections }})
    </span>
    <agr-table
      style="width: 500px"
      *ngIf="!!allocations && allocations.length > 0"
      [config]="allocationsTableConfig"
      data-test="allocations-table"
    >
    </agr-table>
  </div>
</agr-form-dialog>
